export default {
    state: {
        alertMessage: null,
        alertTimeout: 0,
        alertVariant: 'success',
    },
    mutations: {
        showAlertMessage(state, alertInfo) {
            state.alertMessage = alertInfo.message;
            // state.alertTimeout = alertInfo.timeout || 5000;
            state.alertTimeout += 1;
            state.alertVariant = alertInfo.variant || 'success';

            var store = this;
            setTimeout(function () {
                store.commit('hideAlertMessage');
            }, alertInfo.timeout || 10000);
        },
        hideAlertMessage(state) {
            state.alertTimeout -= 1;
        },
    },
};